var $1399fa2c91e4acbb$exports = {};
$1399fa2c91e4acbb$exports = {
    "valid": `Kehtiv`
};


export {$1399fa2c91e4acbb$exports as default};
//# sourceMappingURL=et-EE.module.js.map
